import { handleActions } from 'redux-actions-helpers';
import { showModal, hideModal } from './actions';

export const initialState = {
    show: false,
    src : null
};

export default handleActions({
    [showModal]: (state, { src }) => {
        return {
            ...state,
            show: true,
            src
        }
    },
    [hideModal]: (state) => {
        return {
            ...state,
            show: false,
            src : null
        }
    }
}, { initialState });



// WEBPACK FOOTER //
// ./src/blocks/modal/reducer.js